import React,{useRef} from 'react'
import {useQuery} from "@apollo/client"
import { GET_Udzielone_Odpowiedzi } from '../Graphql/query'
import { useSelector} from "react-redux"
import { useDispatch} from 'react-redux'
import { zapisListaPytan,delListaPytan } from '../Magazyn/kreatorAkcji'

import ListaPytan from '../Komponenty/listaPytan'
import BladLog from '../Komponenty/BladLogowania'

const DostPytan  = () => {
   const dispach   = useDispatch()
   const id        = useSelector((magazyn) => magazyn.opcje)
   const uczestnik = useSelector((magazyn) => magazyn.uczestnik )

   const zmienneQuery = useRef({
      variables : {id_konkursu : Number(id.id_konkursu),id_uczestnika: Number(uczestnik.id)},
      fetchPolicy:'network-only'
  })
   const genLista = (dane) => {
            dispach(delListaPytan(dane))
              dane.kontynuacja_pytania.map(pyt => 
              dispach(zapisListaPytan(pyt))
              )
        }

   const token = sessionStorage.getItem('token')
   const {data,loading,error} = useQuery(GET_Udzielone_Odpowiedzi,zmienneQuery.current)
   if (loading) { return <p>Wczytywanie danych</p>}
   if (error) { if(!token) {return <BladLog/>} else { return <p>Błąd połacznia z bazą danych</p>}}
   genLista(data)
        return(
           <ListaPytan/>
        )
}

export default DostPytan